<template>
  <div id="app" class="d-flex flex-column min-vh-100">
    <Header
      v-if="
        $route.name != 'EN_SignIn' &&
          $route.name != 'EN_Register' &&
          $route.name != 'EN_ForgottenPassword'
      "
    ></Header>
    <HeaderAuth
      v-if="
        $route.name == 'EN_SignIn' ||
          $route.name == 'EN_Register' ||
          $route.name == 'EN_ForgottenPassword'
      "
    ></HeaderAuth>

    <div class="kotha-default-content flex-fill">
      <router-view :key="$route.fullPath" />
    </div>
    <Footer
      v-if="
        $route.name != 'EN_SignIn' &&
          $route.name != 'EN_Register' &&
          $route.name != 'EN_ForgottenPassword'
      "
    ></Footer>
    <MobileAppMenu />

    <div class="update-dialog" v-if="updateExists && isPWA">
      <div class="update-dialog__content">
        A new version of the app is now available.
      </div>
      <div class="update-dialog__actions">
        <button class="btn btn-success mt-2" @click="refreshApp">
          Update
        </button>
      </div>
    </div>

    <cookie-law :buttonText="'OK'">
      <div slot="message">
        This website uses cookies to improve the user experience and provide content. <router-link :to="{
                      name: 'EN_TermsAndConditions',
                    hash: '#politika-piskotkov'
                    }">Več</router-link>
      </div>
    </cookie-law>

  </div>
</template>

<script>
import Header from "@/components/EN_Header";
import HeaderAuth from "@/components/EN_HeaderAuth";
import Footer from "@/components/EN_Footer";
import MobileAppMenu from "@/components/EN_MobileAppMenu";
import firebase from "firebase";
import { version } from "../../package.json";
import globalFunctions from "@/helpers/globalFunctions";
import update from '../mixins/update'
import CookieLaw from 'vue-cookie-law'

export default {
  name: "ZapisiSpominaTemplate",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Zapisi spomina",
    // all titles will be injected into this template
    titleTemplate: "%s | Zapisi spomina",
    changed(metaInfo) {
      firebase.analytics().setCurrentScreen(metaInfo.title);
      firebase.analytics().logEvent("page_view");
      firebase.analytics().logEvent("screen_view", {
        app_name: globalFunctions.isPWA() ? "pwa" : "web",
        screen_name: metaInfo.title,
        app_version: version
      });
    }
  },
  components: {
    Header,
    HeaderAuth,
    Footer,
    MobileAppMenu,
    CookieLaw
  },
  computed: {
    isPWA() {
      return globalFunctions.isPWA()
    }
  },
  data() {
    return {
      prompt: false
    };
  },
  mixins: [update],
  mounted() {
    console.log("mounted");
  },

  methods: {
  }
};
</script>
<style lang="scss">
.update-dialog {
  position: fixed;
  left: 50%;
  bottom: 80px;
  transform: translateX(-50%);
  border-radius: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  padding: 20px;
  max-width: 576px;
  min-width: 300px;
  color: white;
  background-color: #473926;
  text-align: left;
  z-index: 99999999999999999;

  &__actions {
    display: flex;
    margin-top: 8px;
  }

  &__button {
    margin-right: 8px;

    &--confirm {
      margin-left: auto;
    }
  }
}
</style>
